// import {
//   ArrowRightOutlined,
//   CalendarOutlined,
//   ProjectOutlined,
//   ReloadOutlined,
//   TeamOutlined,
// } from "@ant-design/icons";
// import { Card, Col, Empty, Modal, Row, Select, Skeleton, Space, Table, Tag, Typography } from "antd";
// import { useCallback, useEffect, useState } from "react";
// import { BiHome } from "react-icons/bi";
// import { Client } from "../../core/api-client";
// import {
//   API_GET_DASHBOARD_BENCH_PEOPLE,
//   API_GET_DASHBOARD_BENCH_FY_STAFF,
//   API_GET_DASHBOARD_LOW_PROJECT_ASSIGNMENT,
//   API_GET_DASHBOARD_SUMMARY_COUNTS,  
// } from "../../shared/routes/private.routes";
// import DashboardLoadError from "./components/dashboard-load-error.component";
// import MissingFieldsSummary from "./components/missing-fields-summary.component";
// import { isFailedResponse } from "./dashboard-response";
// import "../../assets/styles/dashboard.less";

// const { Text, Title } = Typography;

// type SummaryCounts = {
//   staff: {
//     total: number;
//     active: number;
//     newJoiners: number;
//     inactive: number;
//     noticePeriod: number;
//     draft: number;
//   };
//   project: {
//     total: number;
//     active: number;
//     newProjects: number;
//     inactive: number;
//     draft: number;
//   };
//   alerts: {
//     expiredProjectSow: ProjectSowAlert[];
//     upcomingProjectSow: ProjectSowAlert[];
//     interns: StaffContractAlert[];
//     trainees: StaffContractAlert[];
//     expiredStaffContracts: StaffContractAlert[];
//     upcomingStaffContracts: StaffContractAlert[];
//   };
// };

// type ProjectSowAlert = {
//   projectId: string;
//   projectName: string;
//   l2ProjectName?: string;
//   sowNumber?: string;
//   accountName?: string;
//   endDate: string;
//   daysRemaining: number;
// };

// type StaffContractAlert = {
//   staffId: string;
//   staffName: string;
//   employeeId: string;
//   clientName?: string;
//   startDate?: string;
//   contractEndDate: string;
//   noticePeriodDays?: number | null;
//   daysRemaining: number;
// };

// type BenchPerson = {
//   staffId: string;
//   staffName: string;
//   employeeId: string;
//   designation?: string | null;
//   projectAllocationPercent: number;
//   lopPercent: number;
//   benchPercent: number;
// };
// type BenchFYPerson = {
//   staffId: string;
//   staffName: string;
//   employeeId: string;
//   designation?: string | null;
//   projectAllocationPercent: number;
//   lopPercent: number;
//   benchPercent: number;
// };

// type BenchMonthSummary = {
//   month: string;
//   label: string;
//   total: number;
//   people: BenchPerson[];
// };
// type BenchMonthFYSummary = {
//   month: string;
//   label: string;
//   total: number;
//   people: BenchFYPerson[];
// };

// type BenchMonthKey = "previousMonth" | "currentMonth" | "nextMonth";

// type LowAssignmentPerson = {
//   staffId: string;
//   staffName: string;
//   employeeId: string;
//   designation?: string | null;
//   projectAllocationPercent: number;
// };

// type LowAssignmentSummary = {
//   month: string;
//   label: string;
//   total: number;
//   people: LowAssignmentPerson[];
// };

// type DetailModalConfig =
//   | {
//       title: string;
//       description: string;
//       type: "expired" | "upcoming" | "combined";
//       tableType: "project" | "staff" | "intern" | "trainee";
//       data: ProjectSowAlert[] | StaffContractAlert[];
//     }
//   | {
//       title: string;
//       description: string;
//       type?: "expired" | "upcoming" | "combined";
//       tableType: "bench";
//       data: BenchPerson[];
//     }
//   | {
//       title: string;
//       description: string;
//       type?: "expired" | "upcoming" | "combined";
//       tableType: "benchFY";
//       data: BenchFYPerson[];
//     }
//   | {
//       title: string;
//       description: string;
//       tableType: "lowAssignment";
//       data: LowAssignmentPerson[];
//     }
//   | null;

// const emptyCounts: SummaryCounts = {
//   staff: {
//     total: 0,
//     active: 0,
//     newJoiners: 0,
//     inactive: 0,
//     noticePeriod: 0,
//     draft: 0,
//   },
//   project: {
//     total: 0,
//     newProjects: 0,
//     draft: 0,
//     active: 0,
//     inactive: 0,
//   },
//   alerts: {
//     expiredProjectSow: [],
//     upcomingProjectSow: [],
//     interns: [],
//     trainees: [],
//     expiredStaffContracts: [],
//     upcomingStaffContracts: [],
//   },
// };

// const countItems = {
//   staff: [
//     { label: "New Joiners (Last 30 days)", key: "newJoiners", color: "processing" },
//     { label: "Draft", key: "draft", color: "processing" },
//     { label: "Inactive (Last 30 days)", key: "inactive", color: "default" },
//   ],
//   project: [
//     { label: "New Projects (Last 30 days)", key: "newProjects", color: "processing" },
//     { label: "Active", key: "active", color: "success" },
//     { label: "Draft", key: "draft", color: "processing" },
//     { label: "Inactive (Last 30 days)", key: "inactive", color: "default" },
//   ],
// };

// const staffFeaturedItems = [
//   { label: "Active", key: "active", color: "success" },
//   { label: "Notice Period", key: "noticePeriod", color: "warning" },
// ];

// const DashboardPage = () => {
//   const [missingFieldsRefresh, setMissingFieldsRefresh] = useState(0);
//   const [counts, setCounts] = useState<SummaryCounts>(emptyCounts);
//   const [loading, setLoading] = useState(true);
//   const [benchLoading, setBenchLoading] = useState(true);
//   const [benchfyLoading, setBenchfyLoading] = useState(true);
//   const [error, setError] = useState(false);

//   const [lowAssignmentLoading, setLowAssignmentLoading] = useState(true);
//   const [benchMonths, setBenchMonths] = useState({
//     previousMonth: getEmptyBenchMonth(getPreviousMonthValue()),
//     currentMonth: getEmptyBenchMonth(getCurrentMonthValue()),
//     nextMonth: getEmptyBenchMonth(getNextMonthValue()),
//   });
//   const [benchfyMonths, setBenchfyMonths] = useState({
//     previousMonth: getEmptyBenchMonth(getPreviousMonthValue()),
//     currentMonth: getEmptyBenchMonth(getCurrentMonthValue()),
//     nextMonth: getEmptyBenchMonth(getNextMonthValue()),
//   });
//   const [lowAssignment, setLowAssignment] = useState<LowAssignmentSummary>(
//     getEmptyLowAssignment(getCurrentMonthValue())
//   );
//   const [detailModal, setDetailModal] = useState<DetailModalConfig>(null);
//   const [selectedBenchMonth, setSelectedBenchMonth] =
//     useState<BenchMonthKey>("currentMonth");
//     const [selectedBenchFYMonth, setSelectedBenchFYMonth] =
//     useState<BenchMonthKey>("currentMonth");


//   const loadCounts = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await Client.get(API_GET_DASHBOARD_SUMMARY_COUNTS);
//       if (isFailedResponse(response)) {
//         setError(true);
//         return;
//       }
//       setCounts(normalizeCounts(response?.data?.data));
//     } catch (err) {
//       console.error("Failed to load dashboard summary.", err);
//       setError(true);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadCounts();
//   }, [loadCounts]);

//   const benchPeople = benchMonths[selectedBenchMonth];
//   const benchFYPeople = benchfyMonths[selectedBenchFYMonth];

//   const loadBenchPeople = useCallback(async () => {
//     const monthEntries: { key: BenchMonthKey; month: string }[] = [
//       { key: "previousMonth", month: getPreviousMonthValue() },
//       { key: "currentMonth", month: getCurrentMonthValue() },
//       { key: "nextMonth", month: getNextMonthValue() },
//     ];

//     setBenchLoading(true);
//     try {
//       const responses = await Promise.all(
//         monthEntries.map(({ month }) =>
//           Client.get(API_GET_DASHBOARD_BENCH_PEOPLE, {
//             params: { month },
//           })
//         )
//       );
//       if (responses.some(isFailedResponse)) {
//         setError(true);
//         return;
//       }

//       setBenchMonths(
//         monthEntries.reduce(
//           (acc, entry, index) => ({
//             ...acc,
//             [entry.key]:
//               responses[index]?.data?.data || getEmptyBenchMonth(entry.month),
//           }),
//           {} as Record<BenchMonthKey, BenchMonthSummary>
//         )
//       );
//     } catch (err) {
//       console.error("Failed to load unallocated staff.", err);
//       setError(true);
//     } finally {
//       setBenchLoading(false);
//     }
//   }, []);

//   const loadBenchfyPeople = useCallback(async () => {
//     const monthEntries: { key: BenchMonthKey; month: string }[] = [
//       { key: "previousMonth", month: getPreviousMonthValue() },
//       { key: "currentMonth", month: getCurrentMonthValue() },
//       { key: "nextMonth", month: getNextMonthValue() },
//     ];

//     setBenchfyLoading(true);
//     try {
//       const responses = await Promise.all(
//         monthEntries.map(({ month }) =>
//           Client.get(API_GET_DASHBOARD_BENCH_FY_STAFF, {
//             params: { month },
//           })
//         )
//       );
//       if (responses.some(isFailedResponse)) {
//         setError(true);
//         return;
//       }

//       setBenchfyMonths(
//         monthEntries.reduce(
//           (acc, entry, index) => ({
//             ...acc,
//             [entry.key]:
//               responses[index]?.data?.data || getEmptyBenchMonth(entry.month),
//           }),
//           {} as Record<BenchMonthKey, BenchMonthFYSummary>
//         )
//       );
//     } catch (err) {
//       console.error("Failed to load bench staff.", err);
//       setError(true);
//     } finally {
//       setBenchfyLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadBenchPeople();
//     loadBenchfyPeople();
//   }, [loadBenchPeople, loadBenchfyPeople]);

//   const loadLowAssignment = useCallback(async () => {
//     const month = getCurrentMonthValue();
//     setLowAssignmentLoading(true);
//     try {
//       const response = await Client.get(
//         API_GET_DASHBOARD_LOW_PROJECT_ASSIGNMENT,
//         {
//           params: { month },
//         }
//       );
//       // No setError here: the low-assignment section is not rendered, so its failure must not blank the page.
//       if (isFailedResponse(response)) return;
//       setLowAssignment(response?.data?.data || getEmptyLowAssignment(month));
//     } catch (err) {
//       console.error("Failed to load low project assignment.", err);
//     } finally {
//       setLowAssignmentLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadLowAssignment();
//   }, [loadLowAssignment]);

//   const reloadAll = () => {
//     setMissingFieldsRefresh((value) => value + 1);
//     setError(false);
//     void loadCounts();
//     void loadBenchPeople();
//     void loadBenchfyPeople();
//     void loadLowAssignment();
//   };

//   const projectSowAlerts = [
//     ...[...counts.alerts.expiredProjectSow].sort((a, b) => b.endDate.localeCompare(a.endDate)),
//     ...[...counts.alerts.upcomingProjectSow].sort((a, b) => a.endDate.localeCompare(b.endDate)),
//   ];

//   const staffContractAlerts = [
//     ...counts.alerts.expiredStaffContracts,
//     ...counts.alerts.upcomingStaffContracts,
//   ].sort((a, b) => a.contractEndDate.localeCompare(b.contractEndDate) || a.staffName.localeCompare(b.staffName));

//   return (
//     <div className="app-page dashboard-page">
//       <div className="app-page-header dashboard-page-header">
//         <div>
//           <div className="app-page-title-wrap">
//             <span className="app-page-icon">
//               <BiHome />
//             </span>
//             <Title level={1} className="app-page-title">
//               Dashboard
//             </Title>
//           </div>
//           <p className="app-page-subtitle">Staff and project status overview</p>
//         </div>
//         <button
//           className="dashboard-refresh-button"
//           type="button"
//           onClick={reloadAll}
//           aria-label="Refresh dashboard"
//         >
//           <ReloadOutlined />
//           <span>Refresh</span>
//         </button>
//       </div>

//       {error ? (
//         <DashboardLoadError message="Unable to load dashboard data." onRetry={reloadAll} />
//       ) : (
//       <>
//       <Row gutter={[16, 16]}>
//         <Col xs={24} lg={12}>
//           <SummaryCard
//             title="Total Staff"
//             icon={<TeamOutlined />}
//             total={counts.staff.total}
//             featuredItems={staffFeaturedItems.map((item) => ({
//               ...item,
//               value: counts.staff[item.key as keyof SummaryCounts["staff"]],
//             }))}
//             items={countItems.staff.map((item) => ({
//               ...item,
//               value: counts.staff[item.key as keyof SummaryCounts["staff"]],
//             }))}
//             loading={loading}
//           />
//         </Col>
//         <Col xs={24} lg={12}>
//           <SummaryCard
//             title="Total Projects"
//             icon={<ProjectOutlined />}
//             total={counts.project.total}
//             items={countItems.project.map((item) => ({
//               ...item,
//               value: counts.project[item.key as keyof SummaryCounts["project"]],
//             }))}
//             loading={loading}
//           />
//         </Col>
//       </Row>

//       <Row gutter={[16, 16]} className="dashboard-alert-grid">
//         <Col xs={24} xl={12}>
//           <BenchPeopleSection
//             month={benchPeople}
//             months={benchMonths}
//             selectedMonth={selectedBenchMonth}
//             onSelectedMonthChange={setSelectedBenchMonth}
//             loading={benchLoading}
//             onViewAll={(month) =>
//               setDetailModal({
//                 title: `1. Unallocated Staff - ${month.label}`,
//                 description: "Staff less than 100% allocation",
//                 tableType: "bench",
//                 data: month.people,
//               })
//             }
//           />
//         </Col>
//          <Col xs={24} xl={12}>
//           <BenchFyStaffSection
//             month={benchFYPeople}
//             months={benchfyMonths}
//             selectedMonth={selectedBenchFYMonth}
//             onSelectedMonthChange={setSelectedBenchFYMonth}
//             loading={benchfyLoading}
//             onViewAll={(month) =>
//               setDetailModal({
//                 title: `2. Bench Staff List - ${month.label}`,
//                 description: "Staff who are tagged under Bench",
//                 tableType: "benchFY",
//                 data: month.people,
//               })
//             }
//           />
//         </Col>
//          <Col xs={24} xl={12}>
//           <StaffContractAlertTable
//             title="3. Intern Expiry"
//             description="Intern Contracts - Already Expired & Expiring in next 30 days"
//             data={counts.alerts.interns || []}
//             type="combined"
//             period="Intern"
//             loading={loading}
//             onViewAll={() => setDetailModal({
//               title: "3. Intern Expiry",
//               description: "Intern Contracts - Already Expired & Expiring in next 30 days",
//               type: "combined", tableType: "intern",
//               data: counts.alerts.interns || [],
//             })}
//           />
//         </Col>
//          <Col xs={24} xl={12}>
//           <StaffContractAlertTable
//             title="4. Trainee Expiry"
//             description="Trainees expired in the last 45 days or expiring in the next 30 days"
//             data={counts.alerts.trainees || []}
//             type="combined"
//             period="Trainee"
//             loading={loading}
//             onViewAll={() => setDetailModal({
//               title: "4. Trainee Expiry",
//               description: "Trainees expired in the last 45 days or expiring in the next 30 days",
//               type: "combined", tableType: "trainee",
//               data: counts.alerts.trainees || [],
//             })}
//           />
//         </Col>
//           <Col xs={24} xl={12}>
//           <StaffContractAlertTable
//             title="5.Staff Contract Expiry"
//             description="Expired in the last 45 days or approaching the notice period window"
//             data={staffContractAlerts}
//             type="combined"
//             loading={loading}
//             onViewAll={() =>
//               setDetailModal({
//                 title: "5. Staff Contract Expiry",
//                 description: "Expired in the last 45 days or approaching the notice period window",
//                 type: "combined",
//                 tableType: "staff",
//                 data: staffContractAlerts,
//               })
//             }
//           />
//         </Col>   
//         <Col xs={24} xl={12}>
//           <ProjectSowAlertTable
//             title="6. Project / SOW Expiry"
//             description="Expiring in the next 30 days or expired in the last 90 days"
//             data={projectSowAlerts}
//             type="combined"
//             loading={loading}
//             onViewAll={() =>
//               setDetailModal({
//                 title: "6. Project / SOW Expiry",
//                 description: "Expiring in the next 30 days or expired in the last 90 days",
//                 type: "combined",
//                 tableType: "project",
//                 data: projectSowAlerts,
//               })
//             }
//           />
//         </Col>
       
       
       
        
       
        

//         <Col xs={24}>
//           <MissingFieldsSummary refreshKey={missingFieldsRefresh} />
//         </Col>
//       </Row>
//       </>
//       )}

//       <DashboardDetailModal
//         config={detailModal}
//         onClose={() => setDetailModal(null)}
//       />
    
//     </div>
//   );
// };

// type SummaryCardProps = {
//   title: string;
//   icon: React.ReactNode;
//   total: number;
//   loading: boolean;
//   featuredItems?: {
//     label: string;
//     value: number;
//     color: string;
//   }[];
//   items: {
//     label: string;
//     value: number;
//     color: string;
//   }[];
// };

// function SummaryCard({
//   title,
//   icon,
//   total,
//   featuredItems = [],
//   items,
//   loading,
// }: SummaryCardProps) {
//   const statusItems = [...featuredItems, ...items];

//   return (
//     <Card className="dashboard-summary-card" bordered={false}>
//       {loading ? (
//         <Skeleton active paragraph={{ rows: 4 }} />
//       ) : (
//         <>
//           <div className="dashboard-summary-top">
//             <div className="dashboard-summary-main">
//               <span className="dashboard-summary-icon">{icon}</span>
//               <Text className="dashboard-summary-title">{title}</Text>
//             </div>
//             <div className="dashboard-summary-total">{total}</div>
//           </div>

//           <div className="dashboard-status-grid">
//             {statusItems.map((item) => (
//               <div className="dashboard-status-item" key={item.label}>
//                 <Space size={8}>
//                   <Tag color={item.color}>{item.label}</Tag>
//                 </Space>
//                 <strong>{item.value}</strong>
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </Card>
//   );
// }

// function LowAssignmentSection({
//   data,
//   loading,
//   onViewAll,
// }: {
//   data: LowAssignmentSummary;
//   loading: boolean;
//   onViewAll: () => void;
// }) {
//   return (
//     <Card
//       className="dashboard-low-assignment-card"
//       title={
//         <div className="dashboard-bench-title">
//           <span>5. People With No Project / Low Project Assignment</span>
//           <span>Current month allocation less than or equal to 99%</span>
//         </div>
//       }
//       bordered={false}
//     >
//       <div className="dashboard-low-assignment-count">
//         <Tag color="processing">{data.total}</Tag>
//       </div>
//       <div className="dashboard-low-assignment-table-wrap">
//         <Table<LowAssignmentPerson>
//           size="small"
//           loading={loading}
//           rowKey="staffId"
//           dataSource={data.people.slice(0, 5)}
//           locale={{ emptyText: loading ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
//           pagination={false}
//           columns={getLowAssignmentColumns()}
//         />
//         <ViewAllFooter count={data.people.length} onViewAll={onViewAll} />
//       </div>
//     </Card>
//   );
// }

// function normalizeCounts(data: Partial<SummaryCounts> | undefined): SummaryCounts {
//   return {
//     staff: {
//       ...emptyCounts.staff,
//       ...(data?.staff || {}),
//     },
//     project: {
//       ...emptyCounts.project,
//       ...(data?.project || {}),
//     },
//     alerts: {
//       ...emptyCounts.alerts,
//       ...(data?.alerts || {}),
//     },
//   };
// }

// function BenchPeopleSection({
//   month,
//   months,
//   selectedMonth,
//   onSelectedMonthChange,
//   loading,
//   onViewAll,
// }: {
//   month: BenchMonthSummary;
//   months: {
//     previousMonth: BenchMonthSummary;
//     currentMonth: BenchMonthSummary;
//     nextMonth: BenchMonthSummary;
//   };
//   selectedMonth: BenchMonthKey;
//   onSelectedMonthChange: (month: BenchMonthKey) => void;
//   loading: boolean;
//   onViewAll: (month: BenchMonthSummary) => void;
// }) {
//   const monthOptions = [
//     {
//       label: `Previous Month (${months.previousMonth.label})${loading ? "" : ` - ${months.previousMonth.total}`}`,
//       value: "previousMonth",
//     },
//     {
//       label: `Current Month (${months.currentMonth.label})${loading ? "" : ` - ${months.currentMonth.total}`}`,
//       value: "currentMonth",
//     },
//     {
//       label: `Next Month (${months.nextMonth.label})${loading ? "" : ` - ${months.nextMonth.total}`}`,
//       value: "nextMonth",
//     },
//   ];

//   return (
//     <Card
//       className="dashboard-bench-card"
//       title={
//         <div className="dashboard-bench-header">
//           <div className="dashboard-bench-title">
//             <span>1. Unallocated Staff</span>
//             <span>Staff less than 100% allocation</span>
//           </div>
//           <Select<BenchMonthKey>
//             className="dashboard-bench-month-select"
//             value={selectedMonth}
//             options={monthOptions}
//             onChange={onSelectedMonthChange}
//           />
//         </div>
//       }
//       bordered={false}
//     >
//       <div className="dashboard-bench-table-wrap">
//         <Table<BenchPerson>
//           size="small"
//           loading={loading}
//           rowKey="staffId"
//           dataSource={month.people.slice(0, 5)}
//           locale={{ emptyText: loading ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
//           pagination={false}
//           columns={getBenchColumns()}
//         />
//         <ViewAllFooter
//           count={month.people.length}
//           onViewAll={() => onViewAll(month)}
//         />
//       </div>
//     </Card>
//   );
// }

//   function BenchFyStaffSection({
//   month,
//   months,
//   selectedMonth,
//   onSelectedMonthChange,
//   loading,
//   onViewAll,
// }: {
//   month: BenchMonthFYSummary;
//   months: {
//     previousMonth: BenchMonthFYSummary;
//     currentMonth: BenchMonthFYSummary;
//     nextMonth: BenchMonthFYSummary;
//   };
//   selectedMonth: BenchMonthKey;
//   onSelectedMonthChange: (month: BenchMonthKey) => void;
//   loading: boolean;
//   onViewAll: (month: BenchMonthFYSummary) => void;
// }) {
//   const monthOptions = [
//     {
//       label: `Previous Month (${months.previousMonth.label})${loading ? "" : ` - ${months.previousMonth.total}`}`,
//       value: "previousMonth",
//     },
//     {
//       label: `Current Month (${months.currentMonth.label})${loading ? "" : ` - ${months.currentMonth.total}`}`,
//       value: "currentMonth",
//     },
//     {
//       label: `Next Month (${months.nextMonth.label})${loading ? "" : ` - ${months.nextMonth.total}`}`,
//       value: "nextMonth",
//     },
//   ];

//   return (
//     <Card
//       className="dashboard-bench-card"
//       title={
//         <div className="dashboard-bench-header">
//           <div className="dashboard-bench-title">
//             <span>2. Bench Staff List</span>
//             <span>Staff who are tagged under Bench</span>
//           </div>

//           <Select<BenchMonthKey>
//             className="dashboard-bench-month-select"
//             value={selectedMonth}
//             options={monthOptions}
//             onChange={onSelectedMonthChange}
//           />
//         </div>
//       }
//       bordered={false}
//     >
//       <div className="dashboard-bench-table-wrap">
//         <Table<BenchFYPerson>
//           size="small"
//           loading={loading}
//           rowKey="staffId"
//           dataSource={month.people.slice(0, 5)}
//           locale={{
//             emptyText: loading ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />,
//           }}
//           pagination={false}
//           columns={getBenchFYColumns()}
//         />

//         <ViewAllFooter
//           count={month.people.length}
//           onViewAll={() => onViewAll(month)}
//         />
//       </div>
//     </Card>
//   );
// }

// type AlertTableProps<T> = {
//   title: string;
//   description: string;
//   data: T[];
//   type: "expired" | "upcoming" | "combined";
//   loading: boolean;
//   onViewAll: () => void;
// };

// function ProjectSowAlertTable({
//   title,
//   description,
//   data,
//   type,
//   loading,
//   onViewAll,
// }: AlertTableProps<ProjectSowAlert>) {
//   return (
//     <Card
//       className="dashboard-alert-card"
//       title={
//         <AlertTitle
//           title={title}
//           description={description}
//           count={loading ? undefined : data.length}
//           type={type}
//         />
//       }
//       bordered={false}
//     >
//       <Table<ProjectSowAlert>
//         size="small"
//         loading={loading}
//         rowKey="projectId"
//         dataSource={data.slice(0, 5)}
//         locale={{ emptyText: loading ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
//         pagination={false}
//         columns={getProjectSowColumns(type)}
//         scroll={{ x: type === "combined" ? 760 : undefined }}
//       />
//       <ViewAllFooter count={data.length} onViewAll={onViewAll} />
//     </Card>
//   );
// }

// function StaffContractAlertTable({
//   title,
//   description,
//   data,
//   type,
//   loading,
//   onViewAll,
//   period,
// }: AlertTableProps<StaffContractAlert> & { period?: "Intern" | "Trainee" }) {
//   return (
//     <Card
//       className="dashboard-alert-card"
//       title={
//         <AlertTitle
//           title={title}
//           description={description}
//           count={loading ? undefined : data.length}
//           type={type}
//         />
//       }
//       bordered={false}
//     >
//       <Table<StaffContractAlert>
//         size="small"
//         loading={loading}
//         rowKey="staffId"
//         dataSource={data.slice(0, 5)}
//         locale={{ emptyText: loading ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
//         pagination={false}
//         columns={getStaffContractColumns(type, period)}
//         scroll={{ x: type !== "expired" ? 820 : 595 }}
//       />
//       <ViewAllFooter count={data.length} onViewAll={onViewAll} />
//     </Card>
//   );
// }

// function ViewAllFooter({
//   count,
//   onViewAll,
// }: {
//   count: number;
//   onViewAll: () => void;
// }) {
//   if (!count) {
//     return null;
//   }

//   return (
//     <button className="dashboard-view-all-button" type="button" onClick={onViewAll}>
//       <span>View all</span>
//       <ArrowRightOutlined />
//     </button>
//   );
// }

// function DashboardDetailModal({
//   config,
//   onClose,
// }: {
//   config: DetailModalConfig;
//   onClose: () => void;
// }) {
//   if (!config) {
//     return null;
//   }

//   const isProjectTable = config.tableType === "project";
//   const isBenchTable = config.tableType === "bench";
//   const isBenchFYTable = config.tableType === "benchFY";
//   const isLowAssignmentTable = config.tableType === "lowAssignment";

//   return (
//     <Modal
//       visible
//       centered
//       width="min(1080px, 92vw)"
//       className="dashboard-detail-modal"
//       footer={null}
//       onCancel={onClose}
//       title={
//         <div className="dashboard-detail-title">
//           <span>{config.title}</span>
//           <span>{config.description}</span>
//         </div>
//       }
//     >
//       <div className="dashboard-detail-table-wrap">
//       {isLowAssignmentTable ? (
//         <Table<LowAssignmentPerson>
//           size="small"
//           rowKey="staffId"
//           dataSource={config.data as LowAssignmentPerson[]}
//           columns={getLowAssignmentColumns()}
//           pagination={false}
//           scroll={{ y: 480, x: 760 }}
//         />
//       ) : isBenchTable ? (
//         <Table<BenchPerson>
//           size="small"
//           rowKey="staffId"
//           dataSource={config.data as BenchPerson[]}
//           columns={getBenchColumns()}
//           pagination={false}
//           scroll={{ y: 480, x: 760 }}
//         />
//       ): isBenchFYTable ? (
//         <Table<BenchFYPerson>
//           size="small"
//           rowKey="staffId"
//           dataSource={config.data as BenchFYPerson[]}
//           columns={getBenchFYColumns()}
//           pagination={false}
//           scroll={{ y: 480, x: 760 }}
//         />
//       ): isProjectTable ? (
//         <Table<ProjectSowAlert>
//           size="small"
//           rowKey="projectId"
//           dataSource={config.data as ProjectSowAlert[]}
//           columns={getProjectSowColumns(config.type || "expired")}
//           pagination={false}
//           scroll={{ y: 480, x: 760 }}
//         />
//       ) : (
//         <Table<StaffContractAlert>
//           size="small"
//           rowKey="staffId"
//           dataSource={config.data as StaffContractAlert[]}
//           columns={getStaffContractColumns(config.type || "expired", config.tableType === "intern" ? "Intern" : config.tableType === "trainee" ? "Trainee" : undefined)}
//           pagination={false}
//           scroll={{ y: 480, x: config.type !== "expired" ? 850 : 760 }}
//         />
//       )}
//       </div>
//     </Modal>
//   );
// }

// function getBenchColumns() {
//   return [
//     {
//       title: "Staff",
//       dataIndex: "staffName",
//       ellipsis: true,
//       render: (value: string) => value || "-",
//     },
//     {
//       title: "Designation",
//       dataIndex: "designation",
//       ellipsis: true,
//       render: (value: string | null) => value || "-",
//     },
//     {
//       title: "Unallocated",
//       dataIndex: "benchPercent",
//       width: 120,
//       align: "right" as const,
//       render: (value: number) => (
//         <span style={{ color: "#dc2626", display: "block", fontWeight: 600 }}>
//           {value || 0}%
//         </span>
//       ),
//     },
//   ];
// }

// function getBenchFYColumns() {
//   return [
//     {
//       title: "Staff",
//       dataIndex: "staffName",
//       ellipsis: true,
//       render: (value: string) => value || "-",
//     },
//     {
//       title: "Designation",
//       dataIndex: "designation",
//       ellipsis: true,
//       render: (value: string | null) => value || "-",
//     },
//     {
//       title: "Bench %",
//       dataIndex: "benchPercent",
//       width: 120,
//       align: "right" as const,
//       render: (value: number) => (
//         <span style={{ color: "#dc2626", display: "block", fontWeight: 600 }}>
//           {value || 0}%
//         </span>
//       ),
//     },
//   ];
// }
// function getLowAssignmentColumns() {
//   return [
//     {
//       title: "Staff",
//       dataIndex: "staffName",
//       ellipsis: true,
//       render: (value: string) => value || "-",
//     },
//     {
//       title: "Designation",
//       dataIndex: "designation",
//       ellipsis: true,
//       render: (value: string | null) => value || "-",
//     },
//     {
//       title: "Current Month Allocation",
//       dataIndex: "projectAllocationPercent",
//       width: 210,
//       render: (value: number) => <AllocationBar value={value || 0} />,
//     },
//   ];
// }

// function AllocationBar({ value }: { value: number }) {
//   return (
//     <div className="dashboard-allocation-bar">
//       <div className="dashboard-allocation-track">
//         <span style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }} />
//       </div>
//       <strong>{value}%</strong>
//     </div>
//   );
// }

// function getProjectSowColumns(type: "expired" | "upcoming" | "combined") {
//   return [
//     {
//       title: "Project / SOW",
//       dataIndex: "projectName",
//       ellipsis: true,
//       render: (_: string, row: ProjectSowAlert) => (
//         <div>
//           <strong>{row.l2ProjectName || row.projectName || "-"}</strong>
//           <div className="dashboard-muted-text">SOW: {row.sowNumber || "-"}</div>
//         </div>
//       ),
//     },
//     {
//       title: "Client",
//       dataIndex: "accountName",
//       ellipsis: true,
//       render: (value: string) => value || "-",
//     },
//     {
//       title: "End Date",
//       dataIndex: "endDate",
//       width: 120,
//       render: formatDate,
//     },
//     ...(type === "combined" ? [{
//       title: "Status",
//       dataIndex: "daysRemaining",
//       width: 110,
//       align: "center" as const,
//       render: (value: number) => <Tag style={{ marginInlineEnd: 0 }} color={value < 0 ? "error" : "warning"}>{value < 0 ? "Expired" : "Upcoming"}</Tag>,
//     }] : []),
//     {
//       title: type === "combined" ? "Days" : type === "expired" ? "Overdue" : "Days Left",
//       dataIndex: "daysRemaining",
//       width: 150,
//       align: "center" as const,
//       render: (value: number) => (
//         <Tag
//           color={value < 0 ? "error" : "warning"}
//           style={{ marginInlineEnd: 0, ...(value < 0 ? { color: "#dc2626", fontWeight: 600 } : {}) }}
//         >
//           {Math.abs(value)} {type === "combined" ? (value < 0 ? "days overdue" : "days left") : "days"}
//         </Tag>
//       ),
//     },
//   ];
// }

// function getStaffContractColumns(type: "expired" | "upcoming" | "combined", period?: "Intern" | "Trainee") {
//   return [
//     {
//       title: "Staff",
//       dataIndex: "staffName",
//       width: 180,
//       ellipsis: true,
//       render: (_: string, row: StaffContractAlert) => (
//         <div>
//           <strong>{row.staffName || "-"}</strong>
//           <div className="dashboard-muted-text">ID: {row.employeeId || "-"}</div>
//         </div>
//       ),
//     },
//     {
//       title: "Client",
//       dataIndex: "clientName",
//       width: 140,
//       ellipsis: true,
//       render: (value: string) => value || "-",
//     },
//     ...(period ? [{ title: `${period} Start`, dataIndex: "startDate", width: 125, render: formatDate }] : []),
//     {
//       title: period ? `${period} End` : "Contract End",
//       dataIndex: "contractEndDate",
//       width: 125,
//       render: formatDate,
//     },

//     ...(!period && type !== "expired" ? [{
//       title: "Notice Period",
//       dataIndex: "noticePeriodDays",
//       width: 115,
//       render: (value: number | null) => value != null ? `${value} days` : "-",
//     }] : []),
//     ...(type === "combined" ? [{
//       title: "Status",
//       dataIndex: "daysRemaining",
//       width: 110,
//       render: (value: number) => <Tag color={value < 0 ? "error" : "warning"}>{value < 0 ? "Expired" : "Upcoming"}</Tag>,
//     }] : []),
//     {
//       title: type === "combined" ? "Days" : type === "expired" ? "Overdue" : "Days Left",
//       dataIndex: "daysRemaining",
//       width: 150,
//       render: (value: number) => (
//         <Tag
//           color={value < 0 ? "error" : "warning"}
//           style={
//             value < 0
//               ? { color: "#dc2626", fontWeight: 600 }
//               : undefined
//           }
//         >
//           {Math.abs(value)} {type === "combined" ? (value < 0 ? "days overdue" : "days left") : "days"}
//         </Tag>
//       ),
//     },
//   ];
// }

// function AlertTitle({
//   title,
//   description,
//   count,
//   type,
// }: {
//   title: string;
//   description: string;
//   count?: number;
//   type: "expired" | "upcoming" | "combined";
// }) {
//   return (
//     <div className="dashboard-alert-title">
//       <div className="dashboard-alert-title-main">
//         <Space size={8}>
//           <CalendarOutlined />
//           <span>{title}</span>
//         </Space>
//         <span className="dashboard-alert-window">{description}</span>
//       </div>
//       {count !== undefined && <Tag color={type === "expired" ? "error" : "warning"}>{count}</Tag>}
//     </div>
//   );
// }

// function formatDate(value: string) {
//   if (!value) {
//     return "-";
//   }

//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) {
//     return value;
//   }

//   return date.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }

// function getCurrentMonthValue() {
//   const now = new Date();
//   return formatMonthValue(now);
// }

// export function getPreviousMonthValue(today: Date = new Date()) {
//   const previousMonth = new Date(today);
//   // Move to the 1st first: 31 Oct minus one month would otherwise roll over to 1 Oct.
//   previousMonth.setDate(1);
//   previousMonth.setMonth(previousMonth.getMonth() - 1);
//   return formatMonthValue(previousMonth);
// }

// export function getNextMonthValue(today: Date = new Date()) {
//   const nextMonth = new Date(today);
//   nextMonth.setDate(1);
//   nextMonth.setMonth(nextMonth.getMonth() + 1);
//   return formatMonthValue(nextMonth);
// }

// function formatMonthValue(date: Date) {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   return `${year}-${month}`;
// }

// function getMonthLabel(month: string) {
//   const [year, monthValue] = month.split("-");
//   const date = new Date(Number(year), Number(monthValue) - 1, 1);
//   if (Number.isNaN(date.getTime())) {
//     return month;
//   }

//   return date.toLocaleDateString("en-IN", {
//     month: "short",
//     year: "numeric",
//   });
// }

// function getEmptyBenchMonth(month: string): BenchMonthSummary {
//   return {
//     month,
//     label: getMonthLabel(month),
//     total: 0,
//     people: [],
//   };
// }

// function getEmptyLowAssignment(month: string): LowAssignmentSummary {
//   return {
//     month,
//     label: getMonthLabel(month),
//     total: 0,
//     people: [],
//   };
// }

// export default DashboardPage;


import { MailOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import Title from "antd/es/skeleton/Title";
import React from "react";
import { BiHome } from "react-icons/bi";

const DashboardPage: React.FC = () => {
   
  return (
    <div className="app-page dashboard-page">
       
     
   
<div
  style={{
    width: "100%",
    minHeight: "calc(100vh - 100px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "24px",
    boxSizing: "border-box",
  }}
>
  <h1
    style={{
      fontSize: "36px",
      fontWeight: 700,
      color: "#1677ff",
      margin: 0,
      lineHeight: 1.3,
    }}
  >
    Welcome to Resource Planner
  </h1>

  <p
    style={{
      fontSize: "16px",
      fontWeight: 400,
      color: "#666666",
      marginTop: "16px",
      marginBottom: 0,
      lineHeight: 1.5,
    }}
  >
    Select a module from the sidebar to get started.
  </p>
</div>

  </div>  
)}

export default DashboardPage;

